import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-register-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './register-button.component.html',
  styleUrl: './register-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterButtonComponent {
  readonly buttonDisabled = input<boolean>(false);

  @Output() readonly onRegisterClicked = new EventEmitter<void>();

  onSubmit(): void {
    this.onRegisterClicked.emit();
  }
}
